import firebase from "firebase/app";

import React from "react";

import productionStatuses from "astrid-firestore/src/api/productions/constants/productionStatuses";
import updateProduction from "astrid-firestore/src/api/productions/updateProduction";

import { useMetaGuide } from "../../../../components/production/parts/MetaGuide";
import ProductionInformation from "../../../../components/production/parts/ProductionInformation";
import useHistory from "../../../ui/hooks/useHistory";

import useHasRight from "../../../authorization/hooks/useHasRight";

import ProductionOfferFormButton from "../../components/ProductionOfferForm/ProductionOfferFormButton";

export default function ProductionOverviewViewOld({ production, permissions }) {
	const hasRight = useHasRight();
	const history = useHistory();

	const checkMissing = useMetaGuide((state) => state.checkMissing);

	return (
		<>
			<ProductionInformation
				production={production}
				permissions={permissions}
				checkMissing={() => checkMissing({ history })}
			/>

			{production.status === productionStatuses.OFFER && hasRight("productions.accept") && (
				<ProductionOfferFormButton
					primary
					production={production}
					afterSubmit={() => {
						return updateProduction(firebase, {
							ref: production.ref,
							status: productionStatuses.PLANNING,
						});
					}}
				/>
			)}
		</>
	);
}
